import { Box } from 'reflexbox';
import styled from 'styled-components';

import { Skeleton, tokens } from '@treams/treams-ui';

const TrafficLightElement = styled(Box)<{ signal: 'bad' | 'neutral' | 'good' }>`
	width: 10px;
	height: 10px;
	border-radius: 5px;
	background-color: ${(props) =>
		props.signal === 'bad'
			? props.theme.colors.red
			: props.signal === 'good'
				? props.theme.colors.green
				: tokens.border.subtle};
	flex-shrink: 0;
`;

export function TrafficLight(props: { value?: number; totalUsers?: number; threshold: number }) {
	return (
		<TrafficLightElement
			ml={2}
			signal={
				props.value && props.value >= (props.totalUsers ?? 1) * props.threshold ? 'good' : 'bad'
			}
		/>
	);
}

TrafficLight.Element = TrafficLightElement;

TrafficLight.Skeleton = styled(Skeleton.Box)`
	width: 10px;
	height: 10px;
	border-radius: 5px;
`;
